import type { TFieldKey } from "@./suf-store";
import { useDirectSalesFlowStore } from "../hooks/useDirectSalesFlowStore";
import {
  useDirectSalesFlowErrorStore,
} from "../hooks/useDirectSalesFlowErrorStore";
import { DirectSalesFlowSlug } from "../constants";
import { createFlowValidation } from "../../shared/createFlowValidation";

import { fieldValidationRules } from "./fieldValidationRules";
import { requiredFieldsBySlug } from "./requiredFieldsBySlug";

const { validateField, getRequiredFieldsForSlug } = createFlowValidation<TFieldKey, DirectSalesFlowSlug>({
  getState: useDirectSalesFlowStore.getState,
  errorStore: useDirectSalesFlowErrorStore.getState(),
  fieldRules: fieldValidationRules,
  requiredFieldsBySlug,
});

export { validateField as validateDirectSalesSignUpField, getRequiredFieldsForSlug };
